<div class="flex-row table-container">
    <div class="w-100 flex-column" style="max-width: 1140px; background-color: #fafafa" #stripeDiv>
    </div>
</div>
